import React from "react"
import {
  AcademyButton,
  ButtonWrapper,
  Columns,
  Container,
  EditWrapper,
  Header,
  Id,
  TabListWrapper,
  TabsContainer,
  TopContainer
} from "./ViewOrder.styled"
import { GoBackLink } from "../../../components/Ui/Page/PageHeader.styled"
import Box from "../../../components/Ui/Box"
import { ReactComponent as CopyIcon } from "images/icons/copy.svg"
import { ReactComponent as SettingsIcon } from "images/icons/gear.svg"
import { ReactComponent as AcademyIcon } from "images/icons/graduation-cap.svg"
import { ReactComponent as ArrowLeft } from "images/icons/arrow-left.svg"
import SecondaryButton from "../../../components/Ui/Buttons/SecondaryButton"
import { Tab, TabList, TabPanel, Tabs } from "react-tabs"

const ViewOrderLoading = () => {
  return (
    <Box padding="0" margin="0">
      <TopContainer>
        <GoBackLink to={"/orders"}>
          <ArrowLeft /> Back to orders
        </GoBackLink>
        <AcademyButton
          href={"https://brinkcommerce.featurebase.app/help/collections/6272544-orders"}
          target={"_blank"}
        >
          <AcademyIcon />
        </AcademyButton>
      </TopContainer>
      <Container className={"blur"}>
        <Header>
          <div>
            <h1>Order #444444</h1>
            <div>
              <Id>
                <span>b8a41faf-cdd9-5aac-8ed3-a3819ad39b99</span>
              </Id>
              <Id>
                <span>#444444</span>
              </Id>
            </div>
          </div>
          <EditWrapper>
            <ButtonWrapper>
              <SecondaryButton>
                <CopyIcon />
                Duplicate order
              </SecondaryButton>
              <SecondaryButton>
                <SettingsIcon />
                Update order
              </SecondaryButton>
            </ButtonWrapper>
          </EditWrapper>
        </Header>

        <Columns>
          <TabsContainer>
            <Tabs>
              <TabListWrapper>
                <TabList>
                  <Tab>Order details</Tab>
                  <Tab>Shipping</Tab>
                  <Tab>Payment</Tab>
                  <Tab>Discount</Tab>
                  <Tab>Updates</Tab>
                  <Tab>History log</Tab>
                </TabList>
              </TabListWrapper>
              <TabPanel/>
              <TabPanel/>
              <TabPanel/>
              <TabPanel/>
              <TabPanel/>
              <TabPanel/>
            </Tabs>
          </TabsContainer>
        </Columns>
      </Container>
    </Box>
  )
}

export default ViewOrderLoading
